/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { CreateDefinitionDtoDefinitionLabel } from './CreateDefinitionDtoDefinitionLabel';
import {
    CreateDefinitionDtoDefinitionLabelFromJSON,
    CreateDefinitionDtoDefinitionLabelFromJSONTyped,
    CreateDefinitionDtoDefinitionLabelToJSON,
} from './CreateDefinitionDtoDefinitionLabel';
import type { CreateDefinitionParameterDtoValueType } from './CreateDefinitionParameterDtoValueType';
import {
    CreateDefinitionParameterDtoValueTypeFromJSON,
    CreateDefinitionParameterDtoValueTypeFromJSONTyped,
    CreateDefinitionParameterDtoValueTypeToJSON,
} from './CreateDefinitionParameterDtoValueType';

/**
 * 
 * @export
 * @interface CreateDefinitionParameterDto
 */
export interface CreateDefinitionParameterDto {
    /**
     * 
     * @type {CreateDefinitionParameterDtoValueType}
     * @memberof CreateDefinitionParameterDto
     */
    valueType?: CreateDefinitionParameterDtoValueType | null;
    /**
     * 
     * @type {number}
     * @memberof CreateDefinitionParameterDto
     */
    decimalPlaces?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateDefinitionParameterDto
     */
    inputRangeMin?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateDefinitionParameterDto
     */
    inputRangeMax?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateDefinitionParameterDto
     */
    unitId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateDefinitionParameterDto
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateDefinitionParameterDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateDefinitionParameterDto
     */
    description?: string | null;
    /**
     * 
     * @type {CreateDefinitionDtoDefinitionLabel}
     * @memberof CreateDefinitionParameterDto
     */
    definitionLabel?: CreateDefinitionDtoDefinitionLabel | null;
    /**
     * 
     * @type {string}
     * @memberof CreateDefinitionParameterDto
     */
    parameterIdentifier?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateDefinitionParameterDto
     */
    $type?: CreateDefinitionParameterDtoTypeEnum;
}


/**
 * @export
 */
export const CreateDefinitionParameterDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedDataTypeManagementDtoNumericDtoCreateDefinitionParameterDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.NumericDto.CreateDefinitionParameterDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type CreateDefinitionParameterDtoTypeEnum = typeof CreateDefinitionParameterDtoTypeEnum[keyof typeof CreateDefinitionParameterDtoTypeEnum];



/**
 * Check if a given object implements the CreateDefinitionParameterDto interface.
 */
export function instanceOfCreateDefinitionParameterDto(value?: unknown): value is CreateDefinitionParameterDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(CreateDefinitionParameterDtoTypeEnum)[0];
}

export function CreateDefinitionParameterDtoFromJSON(json: any): CreateDefinitionParameterDto {
    return CreateDefinitionParameterDtoFromJSONTyped(json, false);
}

export function CreateDefinitionParameterDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateDefinitionParameterDto {
    if (json == null) {
        return json;
    }
    return {
        
        'valueType': json['valueType'] == null ? undefined : CreateDefinitionParameterDtoValueTypeFromJSON(json['valueType']),
        'decimalPlaces': json['decimalPlaces'] == null ? undefined : json['decimalPlaces'],
        'inputRangeMin': json['inputRangeMin'] == null ? undefined : json['inputRangeMin'],
        'inputRangeMax': json['inputRangeMax'] == null ? undefined : json['inputRangeMax'],
        'unitId': json['unitId'] == null ? undefined : json['unitId'],
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'definitionLabel': json['definitionLabel'] == null ? undefined : CreateDefinitionDtoDefinitionLabelFromJSON(json['definitionLabel']),
        'parameterIdentifier': json['parameterIdentifier'] == null ? undefined : json['parameterIdentifier'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function CreateDefinitionParameterDtoToJSON(value?: CreateDefinitionParameterDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'valueType': CreateDefinitionParameterDtoValueTypeToJSON(value['valueType']),
        'decimalPlaces': value['decimalPlaces'],
        'inputRangeMin': value['inputRangeMin'],
        'inputRangeMax': value['inputRangeMax'],
        'unitId': value['unitId'],
        'id': value['id'],
        'name': value['name'],
        'description': value['description'],
        'definitionLabel': CreateDefinitionDtoDefinitionLabelToJSON(value['definitionLabel']),
        'parameterIdentifier': value['parameterIdentifier'],
        '$type': value['$type'],
    });
}

